var _circle, _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReactProjectsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 63,
    height: 63,
    viewBox: "0 0 63 63",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 31.5,
    cy: 31.5,
    r: 31,
    fill: "white",
    stroke: "#EFEFEF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.1206 22.3601C36.9606 22.8801 36.7206 23.0801 36.3606 23.0801C36.1606 24.0001 35.5206 24.9601 34.1606 25.3601C34.0406 25.4001 33.9606 25.4001 33.8406 25.4001C33.8006 25.4001 33.7606 25.4001 33.7606 25.4001C32.6406 25.2401 31.5606 24.3601 31.3606 23.0801C30.9606 23.1601 30.6806 22.8801 30.5606 22.2001C30.3606 21.4001 30.6006 21.1201 31.1206 21.2401C30.5206 17.4801 36.1206 18.0801 35.8406 19.0801C35.5606 20.1201 37.0406 18.8401 36.7606 21.2401C37.2806 21.2001 37.2806 21.6801 37.1206 22.3601ZM34.6406 28.2001C34.6806 28.2401 34.6806 28.3201 34.6406 28.3601L34.5206 28.6401V28.6801C34.3606 29.1601 34.1606 29.6401 34.0406 29.9601V30.0001H33.5606V29.9601C33.4406 29.6401 33.2806 29.1601 33.0806 28.6801C33.0806 28.6801 33.0806 28.6801 33.0806 28.6401L32.9606 28.3201C32.9606 28.2801 32.9606 28.2001 32.9606 28.1601L33.4006 27.4001C33.4406 27.3601 33.4006 27.3201 33.3606 27.2801C32.4806 26.5601 32.8406 25.9201 33.7606 25.8801C34.6406 25.9601 35.0406 26.5601 34.1606 27.2801C34.1206 27.3201 34.1206 27.3601 34.1206 27.4001L34.6406 28.2001ZM33.0406 29.9601H29.1206C29.1206 29.9601 29.1206 29.9601 29.0806 29.9601C28.8406 29.9201 28.6806 29.7201 28.5606 29.3601C28.4406 28.6001 28.6406 27.4001 29.2406 27.0801C29.8006 26.7201 30.6406 26.4401 31.5606 26.2001C31.6006 26.2001 31.6806 26.2001 31.6806 26.2801L32.5606 28.5201V28.5601C32.7606 29.0801 32.9206 29.6001 33.0806 29.9201C33.1206 29.9601 33.0806 29.9601 33.0406 29.9601ZM34.6006 29.9601H38.5206C38.5206 29.9601 38.5206 29.9601 38.5606 29.9601C38.8006 29.9201 38.9606 29.7201 39.0806 29.3601C39.2006 28.6001 39.0006 27.4001 38.4006 27.0801C37.8006 26.7201 37.0006 26.4401 36.0806 26.2001C36.0406 26.2001 35.9606 26.2001 35.9606 26.2801L35.0806 28.5201V28.5601C34.8806 29.0801 34.7206 29.6001 34.5606 29.9201C34.5206 29.9601 34.5606 29.9601 34.6006 29.9601Z",
    fill: "url(#paint0_linear_10817_10027)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.7995 32.76H41.8395C41.9995 32.76 42.1195 32.88 42.1195 33.04V34.2C42.1195 34.36 41.9995 34.48 41.8395 34.48H25.7995C25.6395 34.48 25.5195 34.36 25.5195 34.2V33.04C25.5195 32.88 25.6395 32.76 25.7995 32.76ZM25.7995 37.36H41.8395C41.9995 37.36 42.1195 37.48 42.1195 37.64V38.8C42.1195 38.96 41.9995 39.08 41.8395 39.08H25.7995C25.6395 39.08 25.5195 38.96 25.5195 38.8V37.64C25.5195 37.48 25.6395 37.36 25.7995 37.36ZM25.7995 41.96H41.8395C41.9995 41.96 42.1195 42.08 42.1195 42.24V43.4C42.1195 43.56 41.9995 43.68 41.8395 43.68H25.7995C25.6395 43.68 25.5195 43.56 25.5195 43.4V42.24C25.5195 42.08 25.6395 41.96 25.7995 41.96Z",
    fill: "url(#paint1_linear_10817_10027)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3602 49.8801H43.3202C46.3602 49.8801 48.8402 47.4801 48.8402 44.5201V14.4001V13.2801C48.8402 12.6401 48.3202 12.1201 47.6802 12.1201H20.0002C19.3602 12.1201 18.8402 12.6401 18.8402 13.2801V43.3601C18.8402 43.4001 18.8002 43.4401 18.7602 43.4401H14.5202H13.8402C13.4802 43.4401 13.1602 43.7601 13.1602 44.1201V45.8401C13.1602 48.0801 15.0402 49.8801 17.3602 49.8801ZM46.0402 14.4001C46.3202 14.4001 46.5602 14.6401 46.5602 14.9201V44.5201C46.5602 46.2401 45.1202 47.6801 43.3202 47.6801H20.5202C20.4802 47.6801 20.4402 47.6401 20.4802 47.6001C20.9602 46.8401 21.2402 46.0001 21.2402 45.0801V14.9601C21.2402 14.6801 21.4802 14.4401 21.7602 14.4401H46.0402V14.4001Z",
    fill: "url(#paint2_linear_10817_10027)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_10817_10027",
    x1: 33.8206,
    y1: 18.3247,
    x2: 33.8206,
    y2: 30.0001,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#444BAB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#407EB9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_10817_10027",
    x1: 33.8195,
    y1: 32.76,
    x2: 33.8195,
    y2: 43.68,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#444BAB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#407EB9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_10817_10027",
    x1: 31.0002,
    y1: 12.1201,
    x2: 31.0002,
    y2: 49.8801,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#444BAB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#407EB9"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReactProjectsIcon);
export default __webpack_public_path__ + "static/media/reactProjectsIcon.73a0c33373b4537dba0bb25b0fab7871.svg";
export { ForwardRef as ReactComponent };